import React from 'react';
import { Box, Typography } from '@mui/material';

export function MentionContractuel({ sx = {} }) {
  return (
    <Box
      sx={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        color: 'grey.600',
        backgroundColor: '#FFF',
        paddingInline: '8px',
        ...sx,
      }}
    >
      <Typography>Non contractuel</Typography>
    </Box>
  );
}
